import React from 'react';
import classnames from 'classnames';
import styles from './Spinner.scss';

const Spinner = ({
  className,
  size = 'medium', // small, medium, large
  variant = 'gold', // gold, light, dark
  label = 'Loading...',
  animation = 'spin', // spin, pulse
}) => {
  const sizeClass = `${styles[`spinner--${size}`]}`;
  const variantClass = `${styles[`spinner--${variant}`]}`;
  const animationClass = `${styles[`spinner--${animation}`]}`;

  return (
    <div
      className={classnames(styles.spinnerContainer, className)}
      role="status"
      aria-label={label}
    >
      <div
        className={classnames(
          styles.spinner,
          sizeClass,
          variantClass,
          animationClass,
        )}
      >
        <div className={styles.spinnerRing}></div>
        <div className={styles.spinnerRing}></div>
        <div className={styles.spinnerRing}></div>
      </div>
      <span className={styles.srOnly}>{label}</span>
    </div>
  );
};

export default Spinner;
